import AuthenticatedRoute from 'cpc-license-manager/utils/authenticated-route';

export default class DataViewRoute extends AuthenticatedRoute {
  queryParams = {
    page: {
      refreshModel: true,
    },
    perPage: {
      refreshModel: true,
    },
    sortByField: {
      refreshModel: true,
    },
    sortDirection: {
      refreshModel: true,
    },
    searchTerm: {
      refreshModel: true,
    },
  };

  setPagination(params) {
    params.skip = (params.page - 1) * params.perPage;
    params.take = params.perPage;

    delete params.page;
    delete params.perPage;

    return params;
  }
}
